import { Route, Routes } from "react-router-dom";
import PageLogin from "./PageLogin";
import PageHotelInfo from "./PageHotelInfo";
import * as HTTPManager from "./HTTPManager";

function Home() {
  HTTPManager.useAxiosInterceptor();

  return (
    <div className="flex flex-col h-full">
      <Routes>
        <Route path="/" element={<PageLogin />} />
        <Route path="/reservation" element={<PageHotelInfo />} />
      </Routes>
    </div>
  );
}

export default Home;
